import Api from './api'

export default {
  getProfile (credentials) {
    return Api().get('user/profile', credentials)
  },
  setProfile (credentials) {
    return Api().post('user/updateprofile', credentials)
  },
  setAvatar (credentials, axiosConfig) {
    return Api().post('user/setavatar', credentials, axiosConfig)
  },
  removeAvatar (credentials) {
    return Api().post('user/removeavatar', credentials)
  },
  uploadLevellingData (credentials, axiosConfig) {
    console.log('Here')
    return Api().post('user/getlevelling', credentials, axiosConfig)
  },
  setLevellingMatch (credentials, params) {
    return Api().post('user/setlevelling', credentials, params)
  },
  getTogglUsers (credentials) {
    return Api().get('user/togglusers?detail=users', credentials)
  },
  getTogglUserData (credentials, params) {
    return Api().post('user/togglusersdata', credentials, params)
  },
  xeroCredentials (credentials) {
    return Api().post('user/xeroconnect', credentials)
  }, 
}
